import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { ReviewOverviewComponent } from "../features/review/components/review-overview/review-overview.component";
import { AppReviewDetailComponent } from "../features/review/forms/app-review-detail.component/app-review-detail.component";
import { ReviewDetail } from "../features/review/forms/review-detail/review-detail.component";
import { PersonalReviewListResolver } from "../resolver/review/personalReviewList.resolver";
import { ReviewResolver } from "../resolver/review/review.resolver";
import { GetGutachtenValidationErrorsResolver } from "../resolver/anfrage/get-gutachten-validationerrors.resolver";
import { FragenProcessStepComponent } from "../features/anfrage/forms/fragen-process-step/fragen-process-step.component";
import { FragenResolver } from "../resolver/fragen/fragen.resolver";
import { AttachmentsProcessStepComponent } from "../features/anfrage/forms/attachments-process-step/attachments-process-step.component";
import { GetAnfrageContactDataResolver } from "../resolver/anfrage/get-anfrage-contact-data.resolver";
import { GetAllAnfragenDocumenttypesResolver } from "../resolver/anfrage/get-all-anfrage-documenttypes.resolver";
import { GetAllAnfragenAttachmentsResolver } from "../resolver/anfrage/get-all-anfrage-attachments.resolver";
import { UrlWaitResolver } from "../resolver/url-wait.resolver";
import { DataprotectionProcessStepComponent } from "../forms/dataprotection-process-step/dataprotection-process-step.component";

export class ReviewRoutingFactory extends BaseRoutingFactory {

    private readonly coreReviewRoute: Routes = [
        {
            path: '',
            component: ReviewOverviewComponent,
            resolve: {
                gutachtenListe: PersonalReviewListResolver
            },
            runGuardsAndResolvers: 'always'
        },
        {
            path: "detail/:scope/:id",
            component: AppReviewDetailComponent,
            resolve: {
                gutachten: ReviewResolver
            },
            children:[
                {
                    path:"review-detail/:abschnittid",
                    component: ReviewDetail,
                    resolve: {
                        wait: UrlWaitResolver
                    }
                },
                {
                    path: 'questions/:abschnittid',
                    component: FragenProcessStepComponent,
                    resolve: {
                        fragen: FragenResolver
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
                },
                {
                    path: 'attachments/:abschnittid',
                    component: AttachmentsProcessStepComponent,
                    resolve: {
                        contactData: GetAnfrageContactDataResolver,
                        documenttypes: GetAllAnfragenDocumenttypesResolver,
                        attachments: GetAllAnfragenAttachmentsResolver,
                    },
                    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                },
                {
                    path: 'dataprotection',
                    component: DataprotectionProcessStepComponent,
                    //canActivate: [AccessableInDraftGuard],
                    resolve: {
                        errors: GetGutachtenValidationErrorsResolver,
                    },
                },
            ]
        }
    ];
    
    public create(): Routes {
        const coreRoute = this.coreRoute;

        return coreRoute;
    }
    
    protected get coreRoute(): Routes {
        return this.coreReviewRoute;
    }

    protected registerChild(coreRoute: Routes, route: Route): void {
        const formRoutes = coreRoute![1].children!;
        const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
        if (foundIndex >= 0) {
            formRoutes[foundIndex] = route;
        }
        else {
            coreRoute![1].children!.push(route);
        }
    }
    
}